export const IMAGE_UPLOAD_EXT_MIME_TYPES = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    webm: 'video/webm',
    heic: 'image/heic',
    mp4: 'video/mp4',
    avi: 'video/avi',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    pdf: 'application/pdf'
};
